import { useEffect } from 'react'
import { supabase } from '../supabaseClient'

interface RedirectPageProps {
  configKey: string
}

export const RedirectPage = ({ configKey }: RedirectPageProps) => {
  useEffect(() => {
    supabase
      .from('global_configs')
      .select('value')
      .eq('key', configKey)
      .single()
      .then(({ data }) => {
        window.location.href = data?.value || 'https://twopoint.pl'
      })
  }, [configKey])

  return null
}
